import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilteringForm, initialFilteringValues, filteringValidationSchema } from './FilteringForm';
import { PageHeader } from '../../../components/PageHeader';
import { Formik } from "formik";
import OpenInBrowserOutlinedIcon from '@material-ui/icons/OpenInBrowserOutlined';
import Button from '@material-ui/core/Button';


export const ListingPageHeader = (props) => {
    const home = useSelector(state => state.home);

    const {
        setCreating,
        handleFilterChange,
        onExport
    } = props;

    return (
        <PageHeader title="院舍支出 - 付款記錄">
            <Formik
                initialValues={initialFilteringValues}
                validationSchema={filteringValidationSchema}
            >
                {() => (
                    <Fragment>
                        <FilteringForm
                            handleFilterChange={handleFilterChange}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<OpenInBrowserOutlinedIcon />}
                            onClick={onExport}
                        >
                            匯出
                        </Button>
                    </Fragment>
                )}
            </Formik>
        </PageHeader >
    );
}
